import React from "react";
import OptionsComponent from "../OptionsComponent";
import GraphDisplayComponent from "../GraphDisplayComponent";
import ResultComponent from "../ResultComponent";
import { GraphContext } from "../../context";

const MainComponent = () => {
  const { nodes, edges, graphOptions, traverseDetails, traversingEdge } =
    React.useContext(GraphContext);
  const { connection, type } = graphOptions;
  return (
    <div style={{ width: "100%", height: "100vh", display: "flex" }}>
      <OptionsComponent />
      <GraphDisplayComponent
        nodes={nodes}
        edges={edges}
        connection={connection}
        traversingEdge={traversingEdge}
      />
      <ResultComponent content={traverseDetails} typingSpeed={200} />
    </div>
  );
};

export default MainComponent;
